import { PermissionsType } from '@/common/permissionsConst';
import OperationDataReport from '.';

const routes = [
  {
    path: '/operation/data/report',
    permission: PermissionsType.P_OPERATION_DATA_REPORT,
    element: <OperationDataReport />,
  },
];

export default routes;
